<template>
  <div id="login" class="wd" :style="{'min-height': winW <= 1024 ? winH+'px' : 0}">
    <div class="state" v-show="step == 0">
      <h4 class="component_heading">{{ $t('login.heading') }}</h4>
      <p class="top_p">{{ $t('login.provide_phone') }}</p>
      <label><p class="input_hint">{{ $t('login.phone') }}</p>
        <span id="tel_prefix">+380</span><input type="tel" id="tel" autocomplete="off" v-model="loginData.phone" v-mask="'(##) ### ####'" placeholder="(00) XXX XXXX" value="38">
      </label>
      <div class="button" :class="{'active': phoneValid}" @click="requestSMS">{{ $t('login.next') }}</div>
      <div class="errors">
        <p class="status error" v-if="tooManySmsRequests">{{ $t('login.too_many_requests') }}</p>
      </div>
    </div>
    <div class="state" v-show="step == 1">
      <h4 class="component_heading">{{ $t('login.heading') }}</h4>
      <p class="back" @click="backToPhone">&lt;&lt; {{ $t('login.back') }}</p>
      <p class="top_p">{{ $t('login.to_phone') }}
        <b>+380 {{ loginData.phone }}</b> {{ $t('login.sent_sms') }}</p>
        <label for="code">
          <p class="input_hint">{{ $t('login.code_from_sms') }}</p>
          <input ref="codeInput" type="number" id="code" autocomplete="off" required="" v-model="loginData.pass" v-mask="'######'">
        </label>
        <p class="error" v-if="codeVerifyErr">{{ $t('login.wrong_code') }}</p>
      <div class="button" type="submit" :class="{'active': passValid}" @click="authorize">{{ $t('login.enter') }}</div>
      <p class="status waiting" v-if="smsStatus.status == 1">{{ $t('login.sms_sent_waiting') }}</p>
      <p class="status success" v-if="smsStatus.status == 2">{{ $t('login.code_delivered') }} <span v-if="smsStatus.hyber_status == 23022">{{ $t('login.in_push') }}</span><span v-if="smsStatus.hyber_status == 23011">{{ $t('login.in_sms') }}</span><span v-if="smsStatus.hyber_status == 23033">{{ $t('login.in_viber') }}</span></p>
      <div class="errors" v-if="smsStatus.status == 3">
        <p class="status error" v-if="resetByBrowserTimeout">{{ $t('login.delivery_service_down') }}</p>
        <p class="status error" v-if="smsStatus.substatus == 35">{{ $t('login.mes_expired') }}</p>
        <p class="status error" v-if="smsStatus.substatus == 37">{{ $t('login.cell_problems') }}</p>
        <div class="button active" style="width: 100%" @click="retry">{{ $t('login.resend_sms') }}</div>
      </div>
      <div class="button active" style="width: 100%" @click="retry" v-if="resetByBrowserTimeout">{{ $t('login.resend_sms') }}</div>
    </div>
  </div>
  
</template>
<script>
import Store from '../../store'
export default {
  data: function () {
    return {
      loginData: {
        phone: '',
        pass: ''
      },
      step: 0,
      polling: null,
      pollingTimeout: null,
      resetByBrowserTimeout: false,
      browserTimeout: null,
      smsStatus: {
        status: 1
      },
      codeVerifyErr: false,
      tooManySmsRequests: false,
      tooManeAuthTries: false
    }
  },
  computed: {
    winW: function () {
      return Store.state.winW
    },
    winH: function () {
      return Store.state.winH
    },
    trimmedPhone: function () {
      // console.log(this.loginData.phone.replace(/[+() ]/g, ''))
      return this.loginData.phone.replace(/[+() ]/g, '')
    },
    phoneValid: function () {
      return this.trimmedPhone.match(/\d{9}/)
    },
    passValid: function () {
      return this.loginData.pass.match(/^\d{6}$/)
    }
  },
  methods: {
    getPhoneFromCookie: function () {},
    authorize: function () {
      this.$http.post('https://auth.multiplex.ua/verify', {password: this.loginData.pass, in_body: true}).then(response => {
        clearInterval(this.polling)
        window.location = this.$route.query.redirect_uri + '&authorization_code=' + response.body.token
      }, response => {
        if (response.status === 401) {
          this.codeVerifyErr = true
        }
      })
    },
    requestSMS: function () {
      this.$http.post('https://auth.multiplex.ua/login', {login: '380' + this.trimmedPhone}).then(response => {
        if (!response.body.err) {
          this.resetByBrowserTimeout = false
          this.step = 1
          this.requestSMSStatus()
          setTimeout(() => {
            this.$refs.codeInput.focus()
          }, 10)
        }
      }, response => {
        if (response.status === 401) {
          this.tooManySmsRequests = true
        }
      })
    },
    requestSMSStatus: function () {
      this.polling = setInterval(() => {
        this.$http.get('https://auth.multiplex.ua/status').then(response => {
          this.smsStatus = response.body
          if (response.body.status !== 1) {
            clearInterval(this.polling)
            clearTimeout(this.browserTimeout)
            this.resetByBrowserTimeout = false
          }
        })
      }, 2000)
      this.browserTimeout = setTimeout(() => {
        this.resetByBrowserTimeout = true
      }, 20000)
    },
    backToPhone: function () {
      this.step = 0
      clearInterval(this.polling)
      clearTimeout(this.browserTimeout)
    },
    retry: function () {
      clearInterval(this.polling)
      clearTimeout(this.browserTimeout)
      this.requestSMS()
    }
  },
  mounted: function () {
    var ck = this.$cookie.get('UserInfo')
    if (ck) {
      var ckSplit = ck.split('&')
      var ckObj = {}
      for (var i = 0; i < ckSplit.length; i++) {
        var pair = ckSplit[i].split('=')
        ckObj[pair[0]] = pair[1]
      }
      this.loginData.phone = ckObj['UserPhone'].substring(4)
    }
  }
}
</script>



// WEBPACK FOOTER //
// fb-login.vue?5b11dfbd